export enum StepAeromedicaEnum {
  Banner = 1,
  Termos = 2,
  Contrato = 3
}